import { Text } from "nectar-ui";
import React, { useEffect, useState } from "react";
import ArrowTrendIcon from "../../svg/icon/ArrowTrendIcon";

import { squeezeNumber } from "../../utils/helpers/numberHelper";
import {
  StatComparisonContainer,
  StatLabel,
  StatPercentageContainer,
  StatValue,
  StatWrapper,
  ValueContainer,
} from "./style";

const calculatePorcentage = (value: number, previousValue: number) => {
  const difference = value - previousValue;
  const porcentage = difference !== 0 ? (difference * 100) / previousValue : 0;

  if (porcentage % 1 !== 0) return porcentage.toFixed(1);
  return porcentage.toFixed(0);
};

const getIconDirection = (isPositivePorcentage: boolean) => (isPositivePorcentage ? "up" : "down");

const getColor = (porcentage: string) => {
  if (+porcentage === 0) return "gray500";
  if (+porcentage > 0) return "success500";
  return "danger500";
};

interface PorcentageStatProps {
  value: number;
  previousValue?: number;
  comparisonDetails: string;
}

const PorcentageStat = ({ value, previousValue, comparisonDetails }: PorcentageStatProps) => {
  const [stat, setStat] = useState<{ positive: boolean; porcentage: string } | null>(null);

  useEffect(() => {
    if (previousValue !== undefined) {
      if (previousValue === 0 && value >= 1) {
        setStat({ positive: true, porcentage: (value * 100).toString() });
        return;
      }
      const porcentage = calculatePorcentage(value, previousValue);
      const positive = +porcentage >= 1;
      setStat({ positive, porcentage });
    }
  }, [value, previousValue]);

  if (!stat) return null;

  return (
    <StatComparisonContainer>
      <StatPercentageContainer positive={stat.positive}>
        {+stat.porcentage !== 0 && (
          <ArrowTrendIcon
            direction={getIconDirection(stat.positive)}
            color={getColor(stat.porcentage)}
          />
        )}
        <Text noMargin color={getColor(stat.porcentage)}>
          {+stat.porcentage >= 0 && "+"}
          {stat.porcentage}%
        </Text>
      </StatPercentageContainer>
      <Text color="gray500" size="sm">
        {comparisonDetails}
      </Text>
    </StatComparisonContainer>
  );
};

interface StatProps {
  label: string;
  value: number;
  previousValue?: number;
  comparisonDetails?: string;
  onClick?: () => void;
  redValue?: boolean;
  shouldRenderComparison?: boolean;
}

const Stat = ({
  label,
  value,
  previousValue,
  comparisonDetails = "",
  onClick,
  redValue,
  shouldRenderComparison,
}: StatProps) => {
  const VALUE = squeezeNumber(value);

  return (
    <StatWrapper role="button" onClick={onClick} clickable={!!onClick}>
      <ValueContainer>
        <StatLabel>{label}</StatLabel>
        <StatValue redValue={redValue}>{VALUE}</StatValue>
      </ValueContainer>
      {shouldRenderComparison && (
        <PorcentageStat
          value={value}
          previousValue={previousValue}
          comparisonDetails={comparisonDetails}
        />
      )}
    </StatWrapper>
  );
};

export default Stat;
